import Vue from 'vue';
import VueMotion from 'vue-motion';

Vue.use(VueMotion);
